// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoFeedback_container__1vOpq","star":"VideoFeedback_star__3YER_","input":"VideoFeedback_input__3QX48","success":"VideoFeedback_success__uZIkF"};